import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    document.documentElement.classList.toggle("wa-dark")
    const isDark = document.documentElement.classList.contains("wa-dark")
    localStorage.setItem("theme", isDark ? "dark" : "light")
  }
}
